<template>
  <div class="site-config-dialog">
    <el-dialog v-model="dialogShowFlag" class="selectSetDialog" title="站点信息配置" width="60%">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="站点名称" prop="stationName">
          <el-input v-model="form.stationName" placeholder="请输入站点名称" />
        </el-form-item>
        <el-form-item label="所在城市" prop="city">
          <el-input v-model="form.city" placeholder="请输入所在城市" />
        </el-form-item>
        <mapChange
          v-if="dialogShowFlag"
          :map-id="'siteConfigDialogMap'"
          v-model:longitude="form.longitude"
          v-model:latitude="form.latitude"
          v-model:mapName="form.mapName"
          v-model:cityName="form.city"
        ></mapChange>
      </el-form>
      <template #footer>
        <el-button type="primary" :loading="loading" @click="submitForm">提交</el-button>
        <el-button @click="cancel">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, defineExpose, inject, nextTick, defineEmits } from "vue";
import mapChange from "../../map-change.vue";
import { saveKanbanDataApi, getKanbanDataDetailApi } from "@/api/modules/project";
import { ElMessage, ElLoading } from "element-plus";
const receiveTemplateId = inject("templateId");
const receiveProjectModuleId = inject("projectModuleId"); // 默认值为21
const emit = defineEmits(["submit"]);
const dialogShowFlag = ref(false);
const loading = ref(false);
// 定义初始表单对象
const initialForm = {
  stationName: "",
  city: "",
  longitude: "",
  latitude: "",
  mapName: "",
  // 新增字段只需在这里添加
};

// 响应式表单对象
const form = ref(JSON.parse(JSON.stringify(initialForm)));

const rules = {
  stationName: [{ required: true, message: "请输入站点名称", trigger: "blur" }],
  city: [{ required: true, message: "请输入所在城市", trigger: "blur" }],
  longitude: [{ required: true, message: "请输入经度", trigger: "blur" }],
  latitude: [{ required: true, message: "请输入纬度", trigger: "blur" }],
};

const formRef = ref();

// 重置表单方法
const resetForm = () => {
  form.value = JSON.parse(JSON.stringify(initialForm));
  console.log("重置表单", form.value);
  formRef.value?.resetFields();
};
const cancel = () => {
  dialogShowFlag.value = false;
  resetForm();
};
const submitForm = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      loading.value = true;
      const formCopy = JSON.parse(JSON.stringify(form.value));
      const params = {
        sewageBaseInfo: {
          stationName: formCopy.stationName,
          city: formCopy.city,
          longitude: formCopy.longitude,
          latitude: formCopy.latitude,
        },
        moduleId: receiveProjectModuleId.value,
        templateId: receiveTemplateId.value,
      };
      saveKanbanDataApi(params)
        .then((res) => {
          if (res.data.code == 200) {
            loading.value = false;
            dialogShowFlag.value = false;
            ElMessage({
              type: "success",
              message: "保存成功",
            });
            emit("submit");
            resetForm();
          } else {
            loading.value = false;
            ElMessage({
              type: "error",
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          loading.value = false;
        });
    }
  });
};
const getDetail = () => {
  const getDetailLoading = ElLoading.service({ lock: true, text: "Loading", background: "rgba(0, 0, 0, 0.7)" });

  let params = { moduleId: receiveProjectModuleId.value, templateId: receiveTemplateId.value, blockId: 8 };
  getKanbanDataDetailApi(params).then((res) => {
    if (res.data.code == 200) {
      dialogShowFlag.value = true;
      getDetailLoading.close();
      if (!res.data.data.sewageBaseInfo) return;
      Object.assign(form.value, res.data.data.sewageBaseInfo);
      console.log("getKanbanDataDetailApi", form.value);
    }
  });
};
const openDialog = () => {
  getDetail();
};
defineExpose({ openDialog });
</script>

<style lang="scss" scoped></style>
